import React, { forwardRef, useImperativeHandle, useRef } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const Editor = forwardRef(({
  placeholder = "Please type here...",
  setEditorHtml,
  editorHtml,
  onChange,
  disabled = false,
  height = "250px",
  isHeight = true,
  name,
  errors
}, ref) => {
  const editorRef = useRef(null)
  const options = {
    mode: "classic",
    rtl: false,
    katex: "window.katex",
    height: isHeight ? height : 300,
    imageGalleryUrl:
      "https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo",
    videoFileInput: false,
    tabDisable: false,
    font: [
      "Arial",
      "Comic Sans MS",
      "Courier New",
      "Impact",
      "Georgia",
      "Tahoma",
      "Trebuchet MS",
      "Verdana",
      "Times New Roman",
      "Calibri",
    ],
    buttonList: [
      [
        "undo",
        "redo",
        "font",
        "fontSize",
        "formatBlock",
        "paragraphStyle",
        "blockquote",
        "bold",
        "underline",
        "italic",
        "strike",
        "subscript",
        "superscript",
        "fontColor",
        "hiliteColor",
        "textStyle",
        "removeFormat",
        "outdent",
        "indent",
        "align",
        "horizontalRule",
        "list",
        "lineHeight",
        "table",
        "link",
        "image",
        "video",
        "audio",
        "math",
        // "imageGallery",
        "fullScreen",
        "showBlocks",
        "codeView",
        "preview",
        "print",
        "save",
      ],
    ],
    "lang(In nodejs)": "en",
  };

  useImperativeHandle(ref, () => ({
    // This allows the parent to access methods on the child
    focus: () => {
      if (editorRef.current) {
        editorRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" }); // example of focusing the dropdown
      }
    },
  }));
  return (
    <div ref={editorRef} style={errors?{border: '1px solid red'}:{}}>
      <SunEditor
      name={name}
      onChange={onChange}
      setContents={editorHtml}
      placeholder={placeholder}
      disable={disabled}
      // disabled={disabled}
      height={isHeight ? height : ""}
      setOptions={options}
    />
    </div>
  );
});

export default Editor;
